import React from "react";

function VideoModal({ designer }) {
  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog  modal-dialog-centered  modal-lg     ">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <video
              className="w-100"
              src={designer?.introVideo}
              controls
            ></video>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoModal;
